export const OFFERS = {
  active: false,
  text: "🎉USE <b>'GGFIRST3'</b> for FLAT 50% OFF on your first 3 orders!",
  backgroundColor: "#0B9444",
  textColor: "#ffffff",
};

export const DUMMY_ADDONS = [
  {
    id: "6937d597b21aa04c80bb40f0",
    name: "Masala Chaas",
    price: 35,
    _id: "6937d597b21aa04c80bb40f0",
    image:
      "https://www.indianveggiedelight.com/wp-content/uploads/2023/01/masala-chaas-featured.jpg",
    noDiscount: true,
  },
  {
    id: "6937d597b21aa04c80bb40f1",
    name: "Diet Coke",
    price: 58,
    _id: "6937d597b21aa04c80bb40f1",
    image:
      "https://www.shutterstock.com/image-photo/los-angeles-california-united-states-600nw-2485137053.jpg",
    noDiscount: true,
  },
  {
    id: "6937d597b21aa04c80bb40f2",
    name: "Coca Cola (250ml)",
    price: 29,
    _id: "6937d597b21aa04c80bb40f2",
    image:
      "https://www.coca-cola.com/content/dam/onexp/us/en/brands/coca-cola-spiced/coke-product-category-card.png",
    noDiscount: true,
  },
  {
    id: "6937d597b21aa04c80bb40f3",
    name: "Coca Cola (750ml)",
    price: 65,
    _id: "6937d597b21aa04c80bb40f3",
    image:
      "https://5.imimg.com/data5/EB/IC/QX/SELLER-48652903/750ml-coca-cola-soft-drink.jpg",
    noDiscount: true,
  },
  {
    id: "6937d597b21aa04c80bb40f4",
    name: "Water (1 Ltr)",
    price: 29,
    _id: "6937d597b21aa04c80bb40f4",
    image:
      "https://www.mystore.in/s/62ea2c599d1398fa16dbae0a/654b7c1678fdbf4b34b44af4/bw1-640x640.PNG",
    noDiscount: true,
  },
  {
    id: "6937d597b21aa04c80bb40f5",
    name: "Water (500ml)",
    price: 15,
    _id: "6937d597b21aa04c80bb40f5",
    image:
      "https://www.bbassets.com/media/uploads/p/l/265876_2-bisleri-mineral-water.jpg",
    noDiscount: true,
  },
  {
    id: "6937d597b21aa04c80bb40f6",
    name: "Tissue Paper",
    price: 1,
    _id: "6937d597b21aa04c80bb40f6",
    image:
      "https://5.imimg.com/data5/SE/YA/MY-5130277/tissue-paper-napkin-500x500.jpg",
    noDiscount: true,
  }
];
